<script>
import Radio from "@/pages/components/form/horizontal/radio.vue";
import FormGroup from "@/pages/components/form/horizontal/form-group.vue";
import formInput from "@/mixins/shared/formInput";
import MultipleChecks from "@/pages/components/form/input-only/multiple-checks.vue";
import MultipleChecksProps from "@/mixins/shared/multipleChecksProps";

export default {
	mixins: [formInput, MultipleChecksProps],
	components: {MultipleChecks, Radio, FormGroup},
	props: {
		formGroupClasses: {
			type: String,
			default: ''
		}
	}
}
</script>
<template>
	<FormGroup>
		<template #label v-if="$slots.label">
			<slot name="label" />
		</template>

		<template #label v-if="!$slots.label && label">
			{{ label }}
		</template>

		<div class="d-flex gap-2">
			<MultipleChecks
				v-bind="$attrs"
				:form="form"
				:model-value="modelValue"
				:name="name"
				:options="options"
				@update:modelValue="changeModelValueTo"
				:layout="layout"
				:ajax-url="ajaxUrl"
			/>
		</div>
	</FormGroup>
</template>
